import _ from 'lodash';

import {
  fieldTwBasicWifiApAmount,
  BACKEND_KEYS
} from '../../../utils/constant';
import getFieldValue from './getFieldValue';
import { getFieldPriceOrLabel } from './secureBusiness';
import { getLocalizedStrings } from '../../../misc';

export default (fields, steps) => {
  const {
    fields: { formStepFields }
  } = steps.find(s => s.fields.backendKey === BACKEND_KEYS.basicWifiAp);

  const {
    quoteSummary: {
      twBasicWifiApLabel
    }
  } = getLocalizedStrings();

  const product = {};
  const basicWifiApAmountValue = getFieldValue(fieldTwBasicWifiApAmount, fields);
  const basicWifiApAmountPrices = getFieldPriceOrLabel(formStepFields, fieldTwBasicWifiApAmount, true)

  product.amount = {
    value: twBasicWifiApLabel,
    qty: basicWifiApAmountValue,
    prices: basicWifiApAmountPrices
  };

  return {
    ...product,
    totalMonthly:
      _.get(basicWifiApAmountPrices, 'monthly', 0) * +basicWifiApAmountValue,
    totalOneTime: _.get(basicWifiApAmountPrices, 'oneTime', 0)
  };
};
